import React from "react";

import { Box, CircularProgress, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(0, 0, 0, 0.1)",
    // maximum zIndex value https://www.digitalocean.com/community/tutorials/css-z-index
    zIndex: 2147483647,
  },
}));

export const OverlayLoader = () => {
  const styles = useStyles();
  return (
    <Box className={styles.container}>
      <CircularProgress size={110} thickness={5} />
    </Box>
  );
};
